<template>
  <v-dialog v-model="dialogExport" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title> Xuất kho  {{currentTime | display_date('DD-MM-YYYY')}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg7 md7 sm7>
            <v-layout row wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-autocomplete label="Chọn khách hàng" v-model="selectedUID" :items="customers" :item-text="getCustomerText" item-value="ID"></v-autocomplete>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0 ma-0>
                    <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader" :disabled="selectedUID == 0"></v-checkbox>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0>
                  <v-autocomplete v-if="!useBarcodeReader" label="Mã vận đơn" ref="trancode" :items="suggestList" item-text="TransactionCode" item-value="TransactionCode"  v-model="currentTransaction.TransactionCode" :search-input.sync="search" class="input-group--focused" @change="manualChanged"></v-autocomplete>
                    <v-text-field
                    v-else
                    label="Mã vận đơn"
                    ref="trancode"
                    v-model="currentTransaction.TransactionCode"
                    class="input-group--focused"
                    @input="codeChanged"
                    @keyup.enter="manualChanged"
                    :disabled="selectedUID == 0"
                    ></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0>
                    <v-data-table
                    :headers="headers"
                    :items="Packages"
                    :must-sort="true"
                    :mobile-breakpoint="100"
                    disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:item="{ item, index }">
                        <tr>
                        <td>{{ item.TransactionCode }}</td>
                        <td class="text-center">
                            <v-icon small @click="deleteTransaction(index)">fa-trash-alt</v-icon>
                        </td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg5 md5 sm5 pl-3 pr-2>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap pl-5>
                <h-currency-input
                  label="Số lượng"
                  v-model="Packages.length"
                  :decimal="0"
                  readonly
                  class="input-group--focused"
                ></h-currency-input>
                <!-- <v-flex lg12 md12 sm12 pa-0>
                  <v-text-field
                    label="Khách hàng"
                    v-model="CustomerName"
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex> -->
                <v-flex lg12 md12 sm12 pa-0 pt-3>
                  <v-text-field
                    label="Địa chỉ nhận"
                    v-model="Address"
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex lg12 md12 sm12 pa-0 pt-3>
                  <v-text-field
                    label="Điện thoại"
                    v-model="PhoneNumber"
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex> -->
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1 white--text" @click="printItem">In ấn</v-btn>
        <v-btn color="red darken-1 white--text" @click="saveItem">Xuất kho</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import configs from "@/configs";
import Vue from 'vue';
import _ from "lodash";
import { mapState } from "vuex";
import { getCurrentTime, sendErrorNotice, playSound } from "@/commons/utils";
import { request_list, print_export_receipt_order } from '@/commons/hpod';
export default {
  name: "export_popup",
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 5;
    return {
      selectedUID: 0,
      valid: true,
      useBarcodeReader: false,
      autoPackageCode: configs.SYSTEM_CONFIG.auto_pack_code,
      currentTransaction: {
        TransactionCode: ""
      },
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      packcodeRules: [v => (!this.autoPackageCode && !!v) || "Mã lô không được để trống."],
      currentTime: getCurrentTime(),
      Packages: [],
      CustomerName: '',
      Address: '',
      PhoneNumber: '',
      queryTerm: '',

    };
  },
  props: ["dialogExport"],
  watch: {
    useBarcodeReader() {
      if (this.useBarcodeReader) {
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    },
    dialogExport() {
        if(this.dialogExport) {
            this.Packages = [];
            this.selectedUID = 0;
            this.Address = '';
        }
    },
    selectedUID() {
      if(this.selectedUID > 0) {
        this.getSuggestList();
      }
      this.Packages = [];
    }
  },
  computed: {
    ...mapState({
        customers: state => state.customer.master.data,
        suggestTrans: state => state.orderTransaction.suggestList.data
    }),
    search: {
      get () {
        return this.queryTerm
      },
      
      set (searchInput) {
        if (this.queryTerm !== searchInput) {
          this.queryTerm = searchInput;
        }
      }
    },
    suggestList() {
      return _.filter(this.suggestTrans, (p) => {return !_.find(this.Packages, {'TransactionCode': p.TransactionCode})})
    }
  },
  methods: {
    init_data() {
      this.selectedUID = 0;
      this.Address = '';
    },
    getSuggestList() {
      this.$store.dispatch("orderTransaction/getListSuggest", {filter: [{
        column: "Status",
        value: 4,
        condition: "equal",
      },
      {
        column: "UID",
        value: this.selectedUID,
        condition: "equal",
      }]});
    },
    closePopup() {
      this.$emit("closePopup");
    },
    deleteTransaction(index) {
      this.Packages.splice(index, 1);
      this.$nextTick(() => this.$refs.trancode.focus());
    },
    printItem() {
      const frame_printing = print_export_receipt_order({'CustomerName': this.CustomerName, 'PhoneNumber': this.PhoneNumber, 'Address': this.Address}, this.Packages, true);
      var doc = document.getElementById('print_frame').contentWindow.document;
      doc.open();
      doc.write(frame_printing);
      doc.close();
      setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
    },
    saveItem() {
      this.$store.dispatch("orderTransaction/updateMultiple", {
        TransactionIDs: _.map(this.Packages, "ID"),
        Status: 5
      });
    },
    getCustomerText(item) {
      return `${item.UserCode} - ${item.Username}`
    },
    manualChanged() {
      this.$refs.form.validate();
      this.currentTransaction.TransactionCode = this.currentTransaction.TransactionCode == '' ? this.queryTerm : this.currentTransaction.TransactionCode;
      if (this.currentTransaction.TransactionCode !== "" && !this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    codeChanged() {
      this.$refs.form.validate();
      if (this.currentTransaction.TransactionCode !== "" && this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    appendTransactionCode: _.debounce(
      function() {
         var param = {
            filter: [{
                column: "TransactionCode",
                value: this.currentTransaction.TransactionCode,
                condition: "s_equal"
            },
            {
                column: "Status",
                value: 4,
                condition: "equal"
            }]
        };
        const checkTran = _.find(this.Packages, {TransactionCode: this.currentTransaction.TransactionCode})
        if(checkTran) {
          this.currentTransaction = {
            TransactionCode: ""
          };
          this.$nextTick(() => this.$refs.trancode.focus());
          sendErrorNotice('Mã vận đơn đã tồn tại phiếu.')
          return;
        }
        request_list('order_transactions', ret => {
          if(ret.data.length > 0) {
            if(!ret.data[0].Deliverable) {
                sendErrorNotice('Đơn hàng chưa tất toán.');
                playSound('chua-tat-toan-voice.mp3');
                return;
            }
            if(ret.data[0].UID != this.selectedUID) {
                sendErrorNotice('Mã vận đơn không phải của khách hàng đã chọn.');
                playSound('khong-co-voice.mp3')
                return;
            }
            this.Packages.unshift(ret.data[0]);
            if(ret.data[0].ShippingInfo) {
              this.Address = ret.data[0].ShippingInfo;
            }
            this.currentTransaction = {
              TransactionCode: ""
            };
            this.$nextTick(() => this.$refs.trancode.focus());
            playSound('co-voice.mp3');
          }
          else {
            sendErrorNotice('Mã vận đơn chưa nhập kho.')
            playSound('khong-co-voice.mp3')
          }              
        }, Vue.http, param, this.$store.state.authentication.token);
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.init_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.init_data);
  }
};
</script>
